'use client'

import BottomSheet from '@/app/[locale]/_components/Sheet'
import { IRedux } from '@/app/[locale]/_store/types'
import { Box, Button, Flex, Text } from '@chakra-ui/react'
import React, { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import LocationCyan from '@/app/[locale]/_assets/icon-components/LocationCyan'
import {
  activatePoint,
  onOpenMap,
  openPoint,
  removePoint,
  setDeliveryZone,
} from '@/app/[locale]/_store/common/common.slice'
import Edit from '@/app/[locale]/_assets/icon-components/Edit'
import TrashIcon from '@/app/[locale]/_assets/icon-components/Trash'
import { useTranslations } from 'next-intl'
import { toaster } from '@/components/ui/toaster'
import { getCheckPointDeliveryZones } from '@/app/[locale]/_service/zone.service'
import { IPoint } from '@/app/[locale]/_store/common/types'
import ConfirmModal from '../../ConfirmModal'
import { IProps } from '../_types'
import BranchSelectSheet from '../../BranchSelectSheet'
import { useDynamicLanguage } from '@/app/[locale]/_hooks/useShipper'

const Mobile: FC<IProps> = ({ isOpen, onClose }) => {
  const { points } = useSelector((state: IRedux) => state.common)
  const { data } = useSelector((state: IRedux) => state.settings)

  const t = useTranslations()
  const dispatch = useDispatch()
  const [isDelete, setIsDelete] = useState<string>('')
  const [isBottomSheet, setIsBottomSheet] = useState(false)
  const { useDynamicLanguage: dynamicLanguageEnabled } = useDynamicLanguage()

  const isChooseDeliveryBranch = data?.choose_delivery_branch

  const handleClick = () => {
    dispatch(onOpenMap())
    onClose()
  }

  const handleTariffGeozone = (lat: any, lon: any, point: IPoint) => {
    getCheckPointDeliveryZones({ lat, lon }, dynamicLanguageEnabled).then((data) => {
      if (data?.data?.all_count > 0 && !data?.data?.result?.length) {
        toaster.create({
          title: t('address_not_in_service_area'),
          type: 'error',
        })
      } else {
        const currentZone = data?.data?.result?.[0]
        if (currentZone?.id) {
          dispatch(
            setDeliveryZone({
              id: currentZone.id,
              min_order_amount: currentZone.min_order_amount,
            })
          )
        }
        isChooseDeliveryBranch && setIsBottomSheet(true)
        dispatch(activatePoint(point.id))
      }
    })
  }

  const handleSelected = (point: IPoint) => {
    if (point?.location && point?.location?.[0] && point?.location?.[1]) {
      handleTariffGeozone(point?.location[0], point?.location[1], point)
    }
  }

  if (points?.length > 0)
    return (
      <>
        <BottomSheet isOpen={isOpen} onClose={onClose}>
          <Text color={'text'} px={4} fontSize='xl' fontWeight='bold'>
            {t('addresses')}
          </Text>
          <Box>
            {points?.map(
              (point, index) =>
                point && (
                  <Box key={index} py={2} borderBottom='1px solid #E5E5E5'>
                    <Flex align='center' justifyContent='space-between' p={4}>
                      <Flex
                        pr={4}
                        flex={1}
                        align='center'
                        gap={4}
                        onClick={() => {
                          handleSelected(point)
                          onClose()
                        }}
                      >
                        <Box w='24px' h='24px'>
                          <LocationCyan color='var(--primary-default)' />
                        </Box>
                        <Box>
                          <Text color={'text'} fontWeight='bold' fontSize='md'>
                            {point.name || point.address}
                          </Text>
                          <Text
                            wordBreak='break-all'
                            color={'text.muted'}
                            fontSize='sm'
                            lineClamp={1}
                          >
                            {point.name ? point.address : point.city}
                          </Text>
                        </Box>
                      </Flex>
                      <Box display='flex'>
                        {point.name && (
                          <Button
                            w='24px'
                            h='24px'
                            p={0}
                            bg='transparent'
                            onClick={() => dispatch(openPoint(point))}
                          >
                            <Edit />
                          </Button>
                        )}
                        <Button
                          w='24px'
                          h='24px'
                          p={0}
                          bg='transparent'
                          onClick={() => {
                            setIsDelete(point.id)
                          }}
                        >
                          <TrashIcon color='red' />
                        </Button>
                      </Box>
                    </Flex>
                  </Box>
                )
            )}
          </Box>
          <Box px={4} mb={4}>
            <Button
              onClick={handleClick}
              w={'100%'}
              size='xl'
              mt={4}
              rounded={16}
              h={'56px'}
              bg='primary'
              color='primary.text'
              _hover={{
                bg: 'primary.hover',
              }}
            >
              {t('new_address')}
            </Button>
          </Box>
        </BottomSheet>

        <BranchSelectSheet
          isOpen={isBottomSheet}
          onClose={() => setIsBottomSheet(false)}
        />

        <ConfirmModal
          isWarning={true}
          isOpen={Boolean(isDelete)}
          onConfirm={() => {
            toaster.create({
              title: t('address_successfully_deleted'),
              type: 'success',
            })
            dispatch(removePoint(isDelete))
            setIsDelete('')
          }}
          title={t('remove_address')}
          onClose={() => setIsDelete('')}
          description={''}
        />
      </>
    )

  return null
}

export default Mobile
